import { useMemo } from 'react';
import { C, PARTIES } from '../constants';
import { lighten } from '../utils';

export default function Confetti({ active, partyColor }) {
  const pieces = useMemo(() => {
    if (!active) return [];
    const palette = partyColor
      ? [partyColor, lighten(partyColor, 60), lighten(partyColor, 100), C.cyan, C.pink, C.white]
      : [...PARTIES.map(p => p.color), C.cyan, C.pink, C.white];
    return Array.from({ length: 130 }, (_, i) => ({
      id:       i,
      left:     Math.random() * 100,
      delay:    Math.random() * 0.45,
      duration: 2.4 + Math.random() * 2.4,
      color:    palette[Math.floor(Math.random() * palette.length)],
      size:     6 + Math.random() * 10,
      rot:      Math.random() * 720 - 360,
      drift:    (Math.random() - 0.5) * 280,
      isCircle: Math.random() > 0.65,
    }));
  }, [active, partyColor]);

  if (!active) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {pieces.map(p => (
        <div
          key={p.id}
          style={{
            position:        'absolute',
            top:             '-30px',
            left:            `${p.left}%`,
            width:           `${p.size}px`,
            height:          `${p.isCircle ? p.size : p.size * 0.55}px`,
            backgroundColor: p.color,
            borderRadius:    p.isCircle ? '50%' : '2px',
            boxShadow:       `0 0 8px ${p.color}AA`,
            animation:       `tnpoll-confetti ${p.duration}s ${p.delay}s cubic-bezier(.2,.4,.6,1) forwards`,
            '--rot':         `${p.rot}deg`,
            '--drift':       `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
